import * as t from '../actionTypes'
import axios from 'utils/axios'
import { guardFromErrors, extractErrorInfo } from 'utils/graphqlHelpers'
import { TopCampaignsRate } from '../types'

export type FetchTopCampaignsRateReportAction = FSA<undefined, TopCampaignsRate[], string>
type FetchTopCampaignsRateReport = (startDate: Date, endDate: Date, limit?: number) => MrxThunk<FetchTopCampaignsRateReportAction>
type QueryResponse = GraphQLResponse<'topCampaignsRateReport', TopCampaignsRate[]>

const FETCH_TOP_CAMPAIGNS_RATE_REPORT = `
  query fetchTopCampaignsRateReport ($startDate: DateTime!, $endDate: DateTime!, $workspaceId: Int!, $limit: Int) {
    topCampaignsRateReport(startDate: $startDate, endDate: $endDate, workspaceId: $workspaceId, limit: $limit) {
      id
      name
      total
    }
  }
`

const fetchTopCampaignsRateReport: FetchTopCampaignsRateReport = (startDate, endDate, limit) => async (dispatch, getState) => {
  dispatch({
    type: t.FETCH_TOP_CAMPAIGNS_RATE_REPORT,
    meta: { done: false }
  })

  try {
    const {
      workspaces: {
        activeWorkspace: { id: workspaceId }
      }
    } = getState()
    const {
      data: { data, errors }
    }: QueryResponse = await axios.post('/graphql', {
      query: FETCH_TOP_CAMPAIGNS_RATE_REPORT,
      variables: { startDate, endDate, workspaceId, limit }
    })

    guardFromErrors(errors)

    if (!data) {
      throw new Error('Response body is empty!')
    }

    const { topCampaignsRateReport } = data
    if (!topCampaignsRateReport) {
      throw new Error("Can't get Top Campaigns Rate report!")
    }

    dispatch({
      type: t.FETCH_TOP_CAMPAIGNS_RATE_REPORT,
      payload: topCampaignsRateReport,
      meta: { done: true }
    })
  } catch (err) {
    dispatch({
      type: t.FETCH_TOP_CAMPAIGNS_RATE_REPORT,
      payload: extractErrorInfo(err),
      error: true
    })
  }
}

export { fetchTopCampaignsRateReport }
